/* 🤖 this file was generated by svg-to-ts*/
export const iconIndoor: {
  name: 'indoor';
  data: string;
} = {
  name: 'indoor',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17"><path d="M14 14.5h-3V9.75c0-.689-.561-1.25-1.25-1.25h-3.5C5.561 8.5 5 9.061 5 9.75v4.75H2V7.96l6-5.143 6 5.143v6.54zm-7 0h2v-4H7v4zm8.651-7.759l-7-6a.998.998 0 00-1.302 0l-7 6a.998.998 0 00-.349.76v8a1 1 0 001 1h14a1 1 0 001-1v-8a.998.998 0 00-.349-.76z"/></svg>`,
};
